import React from 'react';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import StorySection from './components/StorySection';
import MethodSection from './components/MethodSection';
import BenefitsSection from './components/BenefitsSection';
import ResultsSection from './components/ResultsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-background" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <StorySection data-id="element-3" />
      <MethodSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <ResultsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}